import { useState, useEffect } from "react";
import { Button } from "@mui/material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import GenericFormPopup from "../GenericFormPopup/GenericFormPopup";
import StatusSnackbar from "../../General/StatusSnackbar/StatusSnackbar";
import useAuth from "../../../hooks/useAuth";
import { apiVariable } from "../../../api/apiVariable";
import {
  lenderFieldConfiguration,
  lenderInitialValues,
} from "../../../formConfigs/Fleet/lenderFieldConfig";

interface UpdateLenderPopupProps {
  lender: any;
}

const UpdateLenderPopup = ({ lender }: UpdateLenderPopupProps) => {
  const [open, setOpen] = useState(false);
  const [initialValues, setInitialValues] = useState(lenderInitialValues);
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const queryClient = useQueryClient();
  const { token } = useAuth();

  useEffect(() => {
    if (lender) {
      setInitialValues({
        ...lenderInitialValues,
        ...lender,
      });
    }
  }, [lender]);

  const updateMutation = useMutation({
    mutationFn: (data: any) =>
      axios.put(`${apiVariable}/lender`, data, {
        headers: { Authorization: `Bearer ${token}` },
      }),
    onSuccess: () => {
      setStatus("success");
      queryClient.invalidateQueries({ queryKey: ["lenders"] });
      setOpen(false);
    },
    onError: (error: any) => {
      setStatus("error");
      setErrorMessage(error.response?.data || "Failed to update lender");
    },
  });

  const submitHandler = (data: any) => {
    updateMutation.mutate(data);
  };

  return (
    <>
      <Button variant="contained" color="primary" onClick={() => setOpen(true)}>
        Update
      </Button>
      <GenericFormPopup
        formFields={lenderFieldConfiguration}
        initialValues={initialValues}
        title="Update Lender"
        onSubmit={submitHandler}
        open={open}
        onClose={() => setOpen(false)}
        loading={updateMutation.isPending}
      />
      <StatusSnackbar
        status={status}
        successMessage="Lender updated successfully"
        errorMessage={errorMessage}
        handleClose={() => setStatus("idle")}
      />
    </>
  );
};

export default UpdateLenderPopup;
